import delay from 'lib/utils/delay'
import OrderError from 'lib/../errors/orderError'

interface Arguments {
  validateFunction: (result: any) => Promise<any>,
  failedStatus?: string,
  apiCall: () => Promise<any>,
  maxTime: number,
  waitTime?: number;
}

const pollOrderService = async({ validateFunction, failedStatus, apiCall, maxTime, waitTime = 1000 }: Arguments) => {
  let status = null
  let timeSpent = 0

  while (true) {
    try {
      if (timeSpent > maxTime) {
        throw new OrderError('There was an error processing your order. Please try again.')
      }

      const apiResponse = await apiCall()
      let result
      if ('result' in apiResponse) {
        result = apiResponse.result
      } else {
        result = apiResponse
      }
      status = result.status

      if (status === failedStatus) {
        const orderError = new OrderError(result.message)

        orderError.errors = result.errors
        orderError.refCode = result.ref_code
        throw orderError
      }

      const validateResult = await validateFunction(result)

      if (validateResult) {
        return validateResult
      }

      await delay(waitTime)
      timeSpent = timeSpent + waitTime
    } catch (error) {
      // If we've thrown an order error fail the poll
      // Continue for all other errors i.e. network
      if (error instanceof OrderError) {
        throw error
      }
      await delay(waitTime)
      timeSpent = timeSpent + waitTime
    }
  }
}

export default pollOrderService
